import { translate } from '@web-platform/shared-universal-translations';

import type { NavCard } from './GlobalNavigationFallbackCard/types';

export const NAV_CARD_TYPES = {
  EXPLORE_EVERYWHERE: 'explore-everywhere',
  HOTELS: 'hotels',
  CAR_HIRE: 'car-hire',
  EXPLORE_AI: 'explore-ai',
};

// NavCard Definitions (id is assigned dynamically based on rendered position)
const navCardDefinitions = {
  EXPLORE_AI_CARD: {
    type: NAV_CARD_TYPES.EXPLORE_AI,
    title: 'New - AI search!',
    link: '/explore-ai',
    label: 'New - AI search',
  },
  CAR_HIRE_CARD: {
    type: NAV_CARD_TYPES.CAR_HIRE,
    title: translate('label_navcard_carhire'),
    link: '/carhire',
    label: 'Cars',
  },
  EXPLORE_EVERYWHERE_CARD: {
    type: NAV_CARD_TYPES.EXPLORE_EVERYWHERE,
    title: translate('label_navcard_explore_everywhere'),
    link: '',
    label: 'Explore everywhere',
  },
};

const assignIds = (cards: Array<Omit<NavCard, 'id'>>): NavCard[] =>
  cards.map((card, index) => ({ ...card, id: index + 1 }));

// NavCard Sets. Order is set by Product and must be maintained.
export const getGlobalNavCards = (
  shouldShowExploreAICard: boolean,
  isStaysNavcardEnabled: boolean = false,
): NavCard[] => {
  const hotelsCard = {
    type: NAV_CARD_TYPES.HOTELS,
    title: isStaysNavcardEnabled
      ? translate('homepageTab_stays')
      : translate('label_navcard_hotels'),
    link: '/hotels',
    label: isStaysNavcardEnabled ? 'Stays' : 'Hotels',
  };

  const baseNavCards = [
    hotelsCard,
    navCardDefinitions.CAR_HIRE_CARD,
    navCardDefinitions.EXPLORE_EVERYWHERE_CARD,
  ];

  if (shouldShowExploreAICard) {
    return assignIds([navCardDefinitions.EXPLORE_AI_CARD, ...baseNavCards]);
  }
  return assignIds(baseNavCards);
};
